import { buildItemDetailPath } from "@/shared/constants/route-paths";

type OpenWindow = (
  url: string,
  target: string,
  features: string,
) => unknown;

export function openItemDetailInNewTab(
  itemId: string,
  openWindow: OpenWindow = (url, target, features) =>
    window.open(url, target, features),
) {
  openWindow(
    buildItemDetailPath(itemId),
    "_blank",
    "noopener,noreferrer",
  );
}
